import { setLogger } from './logger.js';

const configsByEnvironment = {
    production: {
        contractID: "intents.near",
        poaBridgeBaseURL: "https://bridge.chaindefuser.com",
        solverRelayBaseURL: "https://solver-relay-v2.chaindefuser.com",
        managerConsoleBaseURL: "https://api-mng-console.chaindefuser.com/api/",
        nearIntentsBaseURL: "https://near-intents.org/api/",
    },
    stage: {
        contractID: "staging-intents.near",
        poaBridgeBaseURL: "https://poa-stage.intents-near.org",
        solverRelayBaseURL: "https://solver-relay-stage.intents-near.org",
        managerConsoleBaseURL: "https://mng-console-stage.intents-near.org/api/",
        nearIntentsBaseURL: "https://stage.near-intents.org/api/",
    },
};
let config = {
    env: configsByEnvironment.production,
    features: {
        hyperliquid: false,
        ton: false,
        optimism: false,
        avalanche: false,
        sui: false,
        near_intents: false,
        stellar: false,
        aptos: false,
    },
};
function configureSDK({ logger, env, features, }) {
    if (logger) {
        setLogger(logger);
    }
    if (typeof env === "string") {
        config = { ...config, env: configsByEnvironment[env] };
    }
    else if (env) {
        config = { ...config, env };
    }
    config = {
        ...config,
        features: {
            ...config.features,
            ...features,
        },
    };
}

export { config, configureSDK };
//# sourceMappingURL=config.js.map
